@if (tenant) {
  <div>
    <div class="full-width card mb-4">
      <div class="card-body">
        <div class="row justify-content-between">
          <div class="col-auto" id="tenantName">
            <h1>{{ tenant[$tenant.name] }} {{ 'label_details' | translate }}</h1>
          </div>
          <div class="col-auto" *appHasPermissions="updateTenantRequiredSecurity">
            <a [routerLink]="['./', Api.edit]" id="editTenantButton">
              {{ 'edit_action' | translate }}
              <svg viewBox="0 0 8 8" class="edit-icon">
                <use xlink:href="#pencil"></use>
              </svg>
            </a>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            @if ((showInternalNotesHideDescription$ | async) && isAdminView) {
              <h2 class="h4">{{ 'tenant_internal_notes' | translate }}</h2>
              <div id="tenantInternalNotes">
                @if (tenant[$tenant.internalNotes]) {
                  {{ tenant[$tenant.internalNotes] }}
                } @else {
                  {{ 'scan_tags_no_internal_notes' | translate }}
                }
              </div>
            } @else if ((showInternalNotesHideDescription$ | async) === false) {
              <h2 class="h4">{{ 'label_description' | translate }}</h2>
              <div id="tenantDescription">
                @if (tenant[$tenant.description]) {
                  {{ tenant[$tenant.description] }}
                } @else {
                  {{ 'scan_tags_no_description' | translate }}
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="full-width card">
      <div class="card-body">
        <ul ngbNav #nav="ngbNav" [activeId]="activeTab$ | async" [destroyOnHide]="true" class="nav-tabs">
          <li
            [ngbNavItem]="$tenantDetailsTabs.workspaces"
            [destroyOnHide]="false"
            *appHasPermissions="readWorkspaceRequiredSecurity"
          >
            <a ngbNavLink routerLink="." [fragment]="$tenantDetailsTabs.workspaces">
              <span>{{ 'administrator_workspaces' | translate }}</span>
            </a>
            <ng-template ngbNavContent>
              <app-tenant-tab-workspaces [tenant]="tenant" [tenantId$]="tenantId$"></app-tenant-tab-workspaces>
            </ng-template>
          </li>
          @if (hasAccessToAcademy$ | async) {
            <li [ngbNavItem]="$tenantDetailsTabs.academy" [destroyOnHide]="true" [disabled]="academyDisabled">
              <a ngbNavLink routerLink="." [fragment]="$tenantDetailsTabs.academy">
                <span>{{ 'academy' | translate }}</span>
              </a>
              <ng-template ngbNavContent>
                <app-tenant-tab-academy [tenant$]="tenant$"></app-tenant-tab-academy>
              </ng-template>
            </li>
          }
        </ul>
        <div class="mt-3" [ngbNavOutlet]="nav"></div>
      </div>
    </div>
  </div>
}
